module.exports = __webpack_public_path__ + "img/crowdmissions.6e615de6.png";